<section class="mt-2">
    <div class="action-btn px-4">
        <button class="mr-5" nz-button nzType="default" (click)="resetForm()">Reset</button>
        <button nz-button nzType="primary" (click)="saveDimList()">Save</button>
    </div>
    <div class="add-catalog-title px-4">
        <h6>Enter {{selectedTab}} Details</h6>
    </div>
    <form [formGroup]="addDimForm">
        <div class="form-container">
            @if(!validForm){
            <div class="d-flex justify-content-end mb-2">
                <span class="text-danger"> Atleast Size Dimension pair is required </span>
            </div>
            }
            @if (dimArray.hasError('nonUniquePairs') && dimArray.touched) {
            <div class="d-flex justify-content-end mb-2">
                <span class="text-danger"> Unique Size Dimension pair is required </span>
            </div>
            }
            <ng-container *ngFor="let list of dimArrList; let i = index">
                <div class="p-4 dimForm-block">
                    <div class="col-md-12" *ngFor="let dimArrForm of dimArrayControls; let j = index">

                        <div class="row align-items-end mb-3" [formGroup]="dimArrForm">
                            @for (panel of list.fields; track panel) {
                            @if(panel.fieldType == 'input'){
                            <ng-container>
                                <div class="col-md-3 mb-1">
                                    <label class="form-label"> {{panel.fieldName}}</label>

                                    <input type="text" class="form-control field-input-{{j}}" (keydown)="blockNonAlphanumeric($event)"
                                        formControlName="{{panel?.formControlName}}" placeholder={{panel?.placeholder}}
                                        uppercase [attr.maxlength]="panel.maxLength ?? null">
                                </div>
                            </ng-container>
                            }
                            @else if(panel.fieldType == 'textarea'){
                            <ng-container>
                                <div class="col-md-5 mb-1"> <!-- Adjusted from 6 to 5 to make room for clear button -->
                                    <label class="form-label"> {{panel.fieldName}}</label>
                                    <!-- Added (keydown.tab) handler to manage your custom tab navigation -->
                                    <textarea type="text" rows="1" class="form-control field-desc-{{j}}"
                                        formControlName="{{panel?.formControlName}}" placeholder={{panel?.placeholder}}
                                        (keydown.tab)="handleDescriptionTab($event, j)"></textarea>
                                </div>
                            </ng-container>
                            }
                            @else if(panel.fieldType == 'select'){
                            <ng-container>
                                <div class="col-md-3 mb-1 d-flex flex-column">
                                    <label class="form-label"> {{panel.fieldName}}</label>
                                    <nz-select nzPlaceHolder={{panel?.placeholder}} nzSize="default"
                                        style="height: 35px !important;" formControlName="{{panel?.formControlName}}">
                                        @for(type of garmentTypes;track type){
                                        <nz-option [nzLabel]="type" [nzValue]="type"></nz-option>
                                        }
                                    </nz-select>
                                </div>
                            </ng-container>
                            }
                            }

                            <!-- Individual Clear Button per Row -->
                            <div class="col-md-1 mb-1 g-0 d-flex align-items-end justify-content-end">
                                <button type="button" nz-button nzType="default" (click)="clearRowForm(j)">
                                    Clear
                                </button>
                            </div>
                        </div>
                        <ng-template #customExpandIcon>
                            <div class="extra-icon-block">
                                <i class="expand-icon" (click)="handleCollapse(j)" nz-icon
                                    [nzType]="!this.addDimForm.get('dimArray')?.value[j].collapse ? 'up' : 'down'"></i>
                            </div>
                        </ng-template>
                        <ng-template #holderIcon>
                            <i class="holder-icon px-3" cdkDragHandle nz-icon nzType='holder'></i>
                        </ng-template>
                    </div>
                </div>
            </ng-container>
        </div>
    </form>
</section>